import Vue from "vue";
import VueRouter, { RawLocation, Route } from "vue-router";
import { ErrorHandler } from "vue-router/types/router";
import { useHistorySaver } from "./guards/history_saver";
import { useTitleUpdater } from "./guards/title_updater";
import { useRoutesChecker } from "./guards/routes_checker";
import { usePreviousPathSaver } from "./guards/previous_path_saver";
import { routes } from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

useHistorySaver(router);
useTitleUpdater(router);
useRoutesChecker(router);
usePreviousPathSaver(router);

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */
const originalPush = router.push;
router.push = function push(
  location: RawLocation,
  onResolve?: Function | undefined | any,
  onReject?: ErrorHandler | undefined
): Promise<Route> {
  if (onResolve || onReject) {
    return (originalPush.call(this, location, onResolve, onReject) as unknown) as Promise<Route>;
  }

  return ((originalPush.call(this, location) as unknown) as Promise<Route>).catch((err: Error) => {
    const reg = new RegExp(
      '^Redirected when going from "[a-z_.\\/]+" to "[a-z_.\\/]+" via a navigation guard.$'
    );

    if (reg.test(err.message)) return (Promise.resolve(false) as unknown) as Route;

    return (Promise.reject(err) as unknown) as Route;
  }) as Promise<Route>;
};

export default router;
